export default __webpack_public_path__ + "static/media/17-PostApocalypticDonut.ef8a4f52.png";